// @ts-nocheck
import { UPDATE_INTEREST_ERROR, UPDATE_INTEREST_LOADING, UPDATE_INTEREST_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const update_interest = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: UPDATE_INTEREST_LOADING,
                data: true
            })
            Authservices.update_interest(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: UPDATE_INTEREST_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: UPDATE_INTEREST_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}